import type { VoiceGender } from "./voices.js";

/**
 * The basename of a recording.
 * @param slug - The headword or sentence the recording says.
 * @param voice - Which of the two controls plays it.
 * @returns A name that remains useful after the file is downloaded.
 */
export function audioFilename(slug: string, voice: VoiceGender): string {
  return `${slug}_${voice}.mp3`;
}
